export default function AddVideoIcon({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18 20.5H4V6.5H13V4.5H4C2.9 4.5 2 5.4 2 6.5V20.5C2 21.6 2.9 22.5 4 22.5H18C19.1 22.5 20 21.6 20 20.5V11.5H18V20.5ZM20 4.5V1.5H18V4.5H15C15.01 4.51 15 6.5 15 6.5H18V9.49C18.01 9.5 20 9.49 20 9.49V6.5H23V4.5H20Z"
        fill="#7F7F7F"
      />
      <path
        d="M14.3216 13.5158L9.44261 10.2638C9.38243 10.2237 9.31248 10.2006 9.24022 10.1971C9.16795 10.1935 9.09608 10.2096 9.03226 10.2437C8.96843 10.2778 8.91504 10.3285 8.87777 10.3905C8.8405 10.4525 8.82074 10.5235 8.82061 10.5958V17.1018C8.82086 17.174 8.84065 17.2448 8.87787 17.3067C8.91509 17.3685 8.96835 17.4192 9.03202 17.4532C9.09568 17.4872 9.16737 17.5034 9.23948 17.5C9.31159 17.4966 9.38144 17.4737 9.44161 17.4338L14.3216 14.1818C14.3765 14.1453 14.4215 14.0958 14.4526 14.0377C14.4837 13.9796 14.5 13.9148 14.5 13.8488C14.5 13.7829 14.4837 13.7181 14.4526 13.66C14.4215 13.6019 14.3765 13.5524 14.3216 13.5158Z"
        fill="#7F7F7F"
      />
    </svg>
  );
}
